<template>
  <div class="vote-banner">
    <div>
      Przez cały <span>tydzień - do piątku</span>, do godz. <span>12:00</span> zapraszamy do głosowania
      na maksymalnie <span>10 dowolnych utworów</span>, znajdujących się w zestawie do głosowania.
      Wyniki głosowania przedstawimy w Liście Przebojów po godz. <span>19:05</span>.
      <br>
      <br>
      Piotr Baron i Marek Niedźwiecki
    </div>
  </div>
</template>

<script>
import mixin from '../mixin';

export default {
  mixins: [mixin],
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
  .vote-banner {
    width: 100%;
    background-image: url('/img/voteBanner.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    margin: 1rem 0;
    padding: 1rem 0;
    border-radius: 5px;
    color: #c5d0ee;
    font-family: 'Poppins', sans-serif;
    font-size: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      width: 80%;
      line-height: 1.5rem;
      text-align: center;
      padding: 2rem 1rem;
    }
    span {
      font-weight: 700;
    }
  }
</style>
